import { SCConfig } from '../app/sc-config/constant/sc-config.constant';
import { environmentDev } from './environment.dev.az';
import { environmentLocal } from './environment.dev.local';
import { environmentStage } from './environment.stg.az';
import { environmentProd } from './environment.prod.az';
import { environmentPreview } from './environment.dev.preview';

// Kept out of main.ts on purpose: main.ts bootstraps the app as a side effect, so importing
// anything from it (e.g. in a component) also boots the whole app wherever that component is
// loaded - including inside the unit-test bundle.
export function getRunTimeEnvironment() {
    const regex = /https?:\/\/(.+)/gm;
    const str = location.origin;
    let matches;
    while ((matches = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (matches.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        for (const match of matches) {
            let foundMatch = null;
            switch (match) {
                case SCConfig.EnvironmentUrls.local:
                    console.debug('Loading local');
                    foundMatch = environmentLocal;
                    break;
                case SCConfig.EnvironmentUrls.dev:
                    console.debug('Loading dev');
                    foundMatch = environmentDev;
                    break;
                case SCConfig.EnvironmentUrls.stage:
                    console.debug('Loading stage');
                    foundMatch = environmentStage;
                    break;
                case SCConfig.EnvironmentUrls.prod:
                    console.debug('Loading prod');
                    foundMatch = environmentProd;
                    break;
            }
            if (foundMatch !== null) {
                return foundMatch;
            }

            if ((match as string).includes('ipex-audit-pr')) {
                console.debug('Loading Preview Environment');
                foundMatch = environmentPreview;
                return foundMatch;
            }
        }
    }
    console.error('No environment matched, setting dev');
    return environmentDev;
}
